(function() {
    'use strict';

    angular.module('product')
        .controller('ProductListController', ProductListController);

    ProductListController.$inject = ['$state', '$scope', '$window', 'productDataSrvc', 'productSrvc', 'notificationSrvc', 'lodashService', 'productMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'productPermissionsConst', 'searchFilterSrvc', 'redirectOutsideSrvc', 'categoryDataSrvc', 'filterQuerySrvc', '$uibModal', 'checkModelPermissionsSrvc', 'siteDataSrvc'];

    function ProductListController($state, $scope, $window, productDataSrvc, productSrvc, notificationSrvc, lodashService, productMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, productPermissionsConst, searchFilterSrvc, redirectOutsideSrvc, categoryDataSrvc, filterQuerySrvc, $uibModal, checkModelPermissionsSrvc, siteDataSrvc) {
        var self = this;

        self.loading = true;
        self.checkboxSelectedProp = "$$checkboxSelected";
        self.productsPublicationLoading = false;
        self.productsUnpublicationLoading = false;
        self.productsLogImportLoading = false;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.productRows = [];
        self.productCols = [{
            title: 'ID',
            value: 'pk',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opublikowany',
            value: 'is_published',
            type: 'boolean',
            searchable: true,
            orderable: true
        }, {
            title: 'Dostępny dla ofert Allegro',
            value: 'is_available_on_allegro',
            type: 'boolean',
            searchable: true,
            orderable: true
        }, {
            title: 'Data od',
            value: 'date_from',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Data do',
            value: 'date_to',
            type: 'text',
            searchable: true,
            orderable: true
        }];
        self.modelPermissions = productPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            pk: null,
            name: null,
            is_published: true,
            is_available_on_allegro: true,
            date_from: null,
            date_to: null,
            ordering: null
        };

        self.filterData = {
            category: null,
            site_pk: null
        };
        self.filterCategories = [];
        self.onFilterChange = onFilterChange;

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;
        self.publishSelectedProducts = publishSelectedProducts;
        self.unpublishSelectedProducts = unpublishSelectedProducts;
        self.importLogsSelectedProducts = importLogsSelectedProducts;
        self.cleanFilters = cleanFilters;

        self.extraActions = [{
            class: 'btn btn-xs',
            iconClass: 'flag flag-pl',
            onClick: redirectPublicPl,
            isDisabled: isRedirectPublicDisabledPl,
            title: 'Sklep Polski'
        }, {
            class: 'btn btn-xs',
            iconClass: 'flag flag-de',
            onClick: redirectPublicDe,
            isDisabled: isRedirectPublicDisabledDe,
            title: 'Sklep Niemiecki'
        }, {
            class: 'btn btn-xs btn-info',
            iconClass: 'fa fa-copy',
            onClick: copyProduct,
            title: 'Skopiuj produkt'
        }];

        self.isCanDisplaySites = false;
        self.siteOptions = [];
        self.initSiteOption = initSiteOption;

        activate();

        function activate() {
            self.isCanDisplaySites = canDisplaySites();
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getSiteOptions(getProducts);
            getFilterCategories();
        }

        function getProducts(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    id: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    is_published: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.is_published),
                    is_available_on_allegro: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.is_available_on_allegro),
                    date_from: searchFilterSrvc.getDateValue(self.searchQuery.date_from),
                    date_to: searchFilterSrvc.getDateValue(self.searchQuery.date_to),
                    category: self.filterData.category,
                    ordering: self.searchQuery.ordering,
                    site_pk: self.filterData.site_pk,
                };
            }
            return productDataSrvc.list(filterObj).$promise.then(
                function(response) {
                    self.productRows = response.results;
                    self.pageOpts.count = response.count;
                    return response;
                },
                function(response) {
                    if (response.status === 404 && filterObj.page !== 1) {
                        checkSearchSrvc.recall(filterObj, getProducts);
                    }
                }
            ).finally(
                function(response) {
                    self.loading = false;
                    return response;
                }
            );
        }

        function getFilterCategories() {
            return categoryDataSrvc.productFilter().$promise
                .then(function(response) {
                    self.filterCategories = response;
                    return response;
                });
        }

        function onCreate() {
            $state.go('layout.product.create');
        }

        function onEdit(row) {
            $state.go('layout.product.update', { pk: row.pk });
        }

        function onDelete(row) {
            return productSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", productMessagesConst.delete);
                lodashService.remove(self.productRows, { pk: row.pk });
                return response;
            });
        }

        function onReorder(row, newPos, dragDirection) {
            if(newPos === undefined)
                return false;

            var replacedRowPos = newPos;
            if(dragDirection > 0) {
                replacedRowPos +=  1;
            } else if(dragDirection < 0) {
                replacedRowPos -= 1;
            }

            var replacedRow = self.productRows[replacedRowPos];
            var newPosition = replacedRow.position;

            return productDataSrvc.update({
                pk: row.pk
            }, {
                position: newPosition
            }).$promise.then(
                function(response) {
                    getProducts();
                    notificationSrvc.notification("success", productMessagesConst.positionChanged);
                    return response;
                },
                function(response) {
                    notificationSrvc.notification("error", productMessagesConst.error);
                }
            );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getProducts();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getProducts();
        }

        function onFilterChange() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getProducts();
        }

        function redirectPublicPl(product) {
            redirectOutsideSrvc.go(product.absolute_public_pl_url);
        }

        function isRedirectPublicDisabledPl(product) {
            return !product.absolute_public_pl_url;
        }

        function redirectPublicDe(product) {
            redirectOutsideSrvc.go(product.absolute_public_de_url);
        }

        function isRedirectPublicDisabledDe(product) {
            return !product.absolute_public_de_url;
        }

        function copyProduct(product) {
            self.loading = true;
            productDataSrvc.copy({
                pk: product.pk
            }).$promise.then(
                function (response) {
                    getProducts();
                    notificationSrvc.notification('success', productMessagesConst.copy);
                    return response;
                },
                function (response) {
                    notificationSrvc.notification("error", productMessagesConst.error);
                    self.loading = false;
                    return response;
                }
            );
        }

        function fixProductsPublishData(data) {
            angular.forEach(data, function (item) {
                var product = lodashService.find(self.productRows, function (row) {
                    return row.pk == item.pk;
                });
                product.is_published = item.is_published;
            });
        }

        function publishSelectedProducts() {
            self.productsPublicationLoading = true;

            var selectedProducts = self.productRows.reduce(function (filtered, row) {
                if (row[self.checkboxSelectedProp]) {
                    filtered.push({pk: row.pk, is_published: true});
                }
                return filtered;
            }, []);

            if (selectedProducts.length) {
                productDataSrvc.publishMany(
                    selectedProducts
                ).$promise.then(
                    function (response) {
                        notificationSrvc.notification('success', productMessagesConst.publishMany);
                        fixProductsPublishData(response);
                        self.productsPublicationLoading = false;
                    },
                    function (response) {
                        notificationSrvc.notification('error', productMessagesConst.error);
                        self.productsPublicationLoading = false;
                    }
                )
            } else {
                notificationSrvc.notification('error', productMessagesConst.productsEmptyError);
                self.productsPublicationLoading = false;
            }
        }

        function unpublishSelectedProducts() {
            self.productsUnpublicationLoading = true;

            var selectedProducts = self.productRows.reduce(function (filtered, row) {
                if (row[self.checkboxSelectedProp]) {
                    filtered.push({pk: row.pk, is_published: false});
                }
                return filtered;
            }, []);

            if (selectedProducts.length) {
                productDataSrvc.publishMany(
                    selectedProducts
                ).$promise.then(
                    function (response) {
                        notificationSrvc.notification('success', productMessagesConst.unpublishMany);
                        fixProductsPublishData(response);
                        self.productsUnpublicationLoading = false;
                    },
                    function (response) {
                        notificationSrvc.notification('error', productMessagesConst.error);
                        self.productsUnpublicationLoading = false;
                    }
                )
            } else {
                notificationSrvc.notification('error', productMessagesConst.productsEmptyError);
                self.productsUnpublicationLoading = false;
            }
        }

        function importLogsSelectedProducts() {
            var selectedProducts = self.productRows.reduce(function (filtered, row) {
                if (row[self.checkboxSelectedProp]) {
                    filtered.push(row.pk);
                }
                return filtered;
            }, []);

            if (selectedProducts.length) {
                $uibModal.open({
                    templateUrl: 'app/product/views/product-log-apply-many-modal/product-log-apply-many-modal.html',
                    controller: 'ProductLogApplyManyModalController',
                    controllerAs: 'ctrl',
                    size: 'lg',
                    resolve: {
                        products: function() {
                            return selectedProducts;
                        }
                    }
                }).result.then(
                    function (results) {
                        return results;
                    }
                );
            } else {
                notificationSrvc.notification('error', productMessagesConst.productsEmptyError);
            }
        }

        function cleanFilters() {
            self.searchQuery = {
                pk: null,
                name: null,
                is_published: null,
                date_from: null,
                date_to: null,
                ordering: null
            };

            $scope.$broadcast('onCleanSearchFilters', {
                searchQuery: self.searchQuery
            })
        }

        function initSiteOption(){
            for (var index in self.siteOptions) {
                var optionPk = self.siteOptions[index].pk
                if (optionPk === config.siteId && self.filterData.site_pk === null){
                    self.filterData.site_pk = optionPk;
                }
            }
        }

        function getSiteOptions(callback) {
            if (self.isCanDisplaySites) {
                var siteIds = checkModelPermissionsSrvc.getPermittedSiteIds(productPermissionsConst.view)
                return siteDataSrvc.getFieldOpts({"ids": siteIds}).$promise.then(
                    function(response) {
                        self.siteOptions = response.results;
                        initSiteOption();
                        callback();
                    });
            } else {
                callback();
            }
        }

        function canDisplaySites() {
            var ids = checkModelPermissionsSrvc.getPermittedSiteIds(productPermissionsConst.view)
            return ids.length > 1;
        }
    }
})();
